import { render, staticRenderFns } from "./HomeProduct.vue?vue&type=template&id=4047bffc&scoped=true&"
import script from "./HomeProduct.vue?vue&type=script&lang=js&"
export * from "./HomeProduct.vue?vue&type=script&lang=js&"
import style0 from "./HomeProduct.vue?vue&type=style&index=0&id=4047bffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047bffc",
  null
  
)

export default component.exports